// Sets variables consumed by various onboarding-related Tags in Google Tag Manager
export const pushGtmDataLayerVariables = ({
  email,
  firstname,
  lastname,
}: {
  email?: string
  firstname?: string
  lastname?: string
}) => {
  const dataLayer = window.dataLayer

  if (!dataLayer) {
    return
  }

  if (email) {
    dataLayer.push({ 'gtm-email': email })
  }

  if (firstname) {
    dataLayer.push({ 'gtm-firstname': firstname })
  }

  if (lastname) {
    dataLayer.push({ 'gtm-lastname': lastname })
  }
}
